import controller from './role-users.controller';

const template = require('./role-users.html');

export default {
    bindings: {
        users: '<',
        onAddUser: '&',
        onRemoveUser: '&'
    },
    controller,
    template
};



// WEBPACK FOOTER //
// ./app/components/users-and-access/roles/role-users/role-users.component.js